export interface ImportSetResults {
  v: number;
  d?: string;
  disabled?: string;
}

export interface ImportSetsAdminListWire {
  totalNumberOfResults: number;
  results: ImportSetResults[];
}

export enum ChangeOptionType {
  Create,
  Copy,
  Import
}
